<template>
  <div>
    <div class="grid-content container">
      <div class="float-layout overlay">
        <a-row type="flex" justify="space-around" align="middle">
          <a-col class="w17-pc">
            <span>当天产能产线负荷情况</span>
          </a-col>
          <a-col class="w5-pc">
            <span>供应商</span>
          </a-col>
          <a-col class="w17-pc">
            <global-select
              :size="small"
              :value.sync="queryParams.itemCode"
              selectType="selectAssembleSearch"
              requestApi="/mes/mesDiscreteJobs/assemblyBox"
              :selectItem="{ value: 'selectedValue', label: 'bringOutDataOne' }"
              searchParam="itemCode"
            />
          </a-col>
          <a-col class="w7-pc">
            <span>排产日期</span>
          </a-col>
          <a-col class="w54-pc">
            <a-date-picker @change="onChange" />
          </a-col>
        </a-row>
      </div>
      <div class="content" id="ipage-chart-send" ref="send"></div>
    </div>
  </div>
</template>
  <script>
import * as echarts from 'echarts'
export default {
  name: 'SchedulingInfoTable',
  components: {},
  mounted () {
    this.renderChart()
  },
  data () {
    // 查询参数
    return {
      queryParams: {
        operationCode: '',
        xuqiushijian: '',
        itemCode: ''
        }
    }
  },
  methods: {
    renderChart () {
      const myChart = echarts.init(this.$refs.send)
      var option

      // var colors = ['#5470C6', '#EE6666'];

      option = {
        xAxis: {
          type: 'category',
          data: ['产线1', '产线2', '产线3', '产线4', '产线5', '产线6']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [
              120,
              {
                value: 200,
                itemStyle: {
                  color: '#a90000'
                }
              },
              150,
              80,
              70,
              110
            ],
            type: 'bar'
          }
        ]
      }

      option && myChart.setOption(option)
    }
  }
}
</script>
  <style lang="less" scoped>
.grid-content {
  width: 100%;
  border-radius: 4px;
  min-height: 36px;
  background: rgb(255, 255, 255);
}
.container {
  position: relative;
  // width: 300px;
  // height: 200px;
  height: 250px;
  // width: 1000px
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2; /* 设置较高的 z-index 值 */
}

.content {
  position: relative;
  z-index: 1; /* 设置较低的 z-index 值 */
  height: 200px;
  width: 1000px
}
/deep/.ant-select{
  width: 150px;
}
.w17-pc {
  width: 17%;
}
.w5-pc {
  width: 5%;
}
.w7-pc {
  width: 7%;
}
.w54-pc {
  width: 54%;
}
</style>
